"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
interface PayloadErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
export default function PayloadErrorDialog(t0) {
  const $ = _c(61);
  const {
    isOpen,
    onClose
  } = t0;
  const {
    theme
  } = useTheme();
  const isDarkMode = theme === "dark";
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = () => {
      const handleEsc = e => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      if (isOpen) {
        document.addEventListener("keydown", handleEsc);
        document.body.style.overflow = "hidden";
      }
      return () => {
        document.removeEventListener("keydown", handleEsc);
        document.body.style.overflow = "";
      };
    };
    t2 = [isOpen, onClose];
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  let t3;
  if ($[4] !== onClose) {
    t3 = <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fade-in" onClick={onClose} />;
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `relative w-full max-w-md mx-4 rounded-2xl shadow-2xl animate-slide-up overflow-hidden ${isDarkMode ? "bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border border-white/10" : "bg-white border border-slate-200"}`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-red-500 via-orange-500 to-red-500" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `w-20 h-20 rounded-full flex items-center justify-center ${isDarkMode ? "bg-gradient-to-br from-red-500/20 to-orange-500/20 border border-red-500/30" : "bg-gradient-to-br from-red-50 to-orange-50 border border-red-200"}`;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-4xl">📄</span>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <div className="flex justify-center mb-6"><div className={t6}>{t7}</div></div>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = `text-2xl font-bold text-center mb-2 ${isDarkMode ? "text-white" : "text-slate-900"}`;
  let t10;
  if ($[10] !== t9) {
    t10 = <h2 className={t9}>Resume Too Long</h2>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = `text-center mb-6 ${isDarkMode ? "text-slate-400" : "text-slate-600"}`;
  let t12;
  if ($[12] !== t11) {
    t12 = <p className={t11}>The resume content exceeds our analysis limit (50,000 characters).</p>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = `rounded-xl p-4 mb-6 ${isDarkMode ? "bg-red-500/10 border border-red-500/20" : "bg-red-50 border border-red-200"}`;
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-xl mt-0.5">⚠️</span>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = `text-sm font-medium mb-1 ${isDarkMode ? "text-white" : "text-slate-900"}`;
  let t16;
  if ($[15] !== t15) {
    t16 = <p className={t15}>Why this happened?</p>;
    $[15] = t15;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  const t17 = `text-sm ${isDarkMode ? "text-slate-400" : "text-slate-600"}`;
  let t18;
  if ($[17] !== t17) {
    t18 = <p className={t17}>Your PDF might contain hidden text, large embedded data, or is extremely long (10+ pages).</p>;
    $[17] = t17;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== t16 || $[20] !== t18) {
    t19 = <div className="flex items-start gap-3">{t14}<div>{t16}{t18}</div></div>;
    $[19] = t16;
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== t13 || $[23] !== t19) {
    t20 = <div className={t13}>{t19}</div>;
    $[22] = t13;
    $[23] = t19;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  const t21 = `rounded-xl p-4 mb-6 ${isDarkMode ? "bg-white/5 border border-white/10" : "bg-slate-50 border border-slate-200"}`;
  const t22 = `text-sm font-medium mb-2 ${isDarkMode ? "text-slate-300" : "text-slate-700"}`;
  let t23;
  if ($[25] !== t22) {
    t23 = <p className={t22}>💡 How to fix it:</p>;
    $[25] = t22;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  const t24 = `text-sm space-y-1 ${isDarkMode ? "text-slate-400" : "text-slate-600"}`;
  let t25;
  let t26;
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <li>• Try uploading a <strong>DOCX version</strong> (often smaller)</li>;
    t26 = <li>• Remove unnecessary pages or appendices</li>;
    t27 = <li>• "Print to PDF" to clean up hidden data</li>;
    $[27] = t25;
    $[28] = t26;
    $[29] = t27;
  } else {
    t25 = $[27];
    t26 = $[28];
    t27 = $[29];
  }
  let t28;
  if ($[30] !== t24) {
    t28 = <ul className={t24}>{t25}{t26}{t27}</ul>;
    $[30] = t24;
    $[31] = t28;
  } else {
    t28 = $[31];
  }
  let t29;
  if ($[32] !== t21 || $[33] !== t23 || $[34] !== t28) {
    t29 = <div className={t21}>{t23}{t28}</div>;
    $[32] = t21;
    $[33] = t23;
    $[34] = t28;
    $[35] = t29;
  } else {
    t29 = $[35];
  }
  const t30 = `flex-1 py-3 px-4 rounded-xl font-semibold transition-all ${isDarkMode ? "bg-white/10 hover:bg-white/15 text-white border border-white/10" : "bg-slate-100 hover:bg-slate-200 text-slate-700 border border-slate-200"}`;
  let t31;
  if ($[36] !== onClose || $[37] !== t30) {
    t31 = <button onClick={onClose} className={t30}>Cancel</button>;
    $[36] = onClose;
    $[37] = t30;
    $[38] = t31;
  } else {
    t31 = $[38];
  }
  let t32;
  if ($[39] !== onClose) {
    t32 = <button onClick={onClose} className="flex-1 py-3 px-4 rounded-xl font-semibold bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white transition-all shadow-lg shadow-red-500/25">Try Another File</button>;
    $[39] = onClose;
    $[40] = t32;
  } else {
    t32 = $[40];
  }
  let t33;
  if ($[41] !== t31 || $[42] !== t32) {
    t33 = <div className="flex gap-3">{t31}{t32}</div>;
    $[41] = t31;
    $[42] = t32;
    $[43] = t33;
  } else {
    t33 = $[43];
  }
  let t34;
  if ($[44] !== t10 || $[45] !== t12 || $[46] !== t20 || $[47] !== t29 || $[48] !== t33 || $[49] !== t8) {
    t34 = <div className="p-6 pt-8">{t8}{t10}{t12}{t20}{t29}{t33}</div>;
    $[44] = t10;
    $[45] = t12;
    $[46] = t20;
    $[47] = t29;
    $[48] = t33;
    $[49] = t8;
    $[50] = t34;
  } else {
    t34 = $[50];
  }
  const t35 = `absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isDarkMode ? "hover:bg-white/10 text-slate-400 hover:text-white" : "hover:bg-slate-100 text-slate-400 hover:text-slate-600"}`;
  let t36;
  if ($[51] !== onClose || $[52] !== t35) {
    t36 = <button onClick={onClose} className={t35}>✕</button>;
    $[51] = onClose;
    $[52] = t35;
    $[53] = t36;
  } else {
    t36 = $[53];
  }
  let t37;
  if ($[54] !== t34 || $[55] !== t36 || $[56] !== t4) {
    t37 = <div className={t4}>{t5}{t34}{t36}</div>;
    $[54] = t34;
    $[55] = t36;
    $[56] = t4;
    $[57] = t37;
  } else {
    t37 = $[57];
  }
  let t38;
  if ($[58] !== t3 || $[59] !== t37) {
    t38 = <div className="fixed inset-0 z-[9999] flex items-center justify-center">{t3}{t37}</div>;
    $[58] = t3;
    $[59] = t37;
    $[60] = t38;
  } else {
    t38 = $[60];
  }
  return t38;
}